import { withAITracking } from "@microsoft/applicationinsights-react-js";
import React from "react";
import Col from "react-bootstrap/esm/Col";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import { Image } from "react-bootstrap";
import { reactPlugin } from "../../../utilities/AppInsights";
import FullLogo from '../../../assets/full_logo.png'
import "./AuthErrorPage.css"

type Props = {
  error?: Error;
}

class AuthErrorPage extends React.Component<Props> {
  render() {
    return (
      <Container className="d-flex align-items-stretch fill-screen">
        <Row className="justify-content-md-center">
          <Col className="align-self-center">
            <Image src={FullLogo} fluid />
          </Col>
          <Col className="align-self-center">
            <h1>Oops..</h1>
            <p>
              {this.props.error?.message ?? 'There was an issue logging you in.'}
            </p>
            <p>
              If you have questions, or believe this was shown to you in error, please reach out to {<a href="mailto:support@aggroloans.com">agGRO Support</a>} for assistance. Sorry for the inconvenience!
            </p>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default withAITracking(reactPlugin, AuthErrorPage);
